var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6408 8.96429L18.9224 0.5H17.1969L10.8743 7.84942L5.82442 0.5H0L7.63638 11.6136L0 20.4897H1.72561L8.40246 12.7285L13.7355 20.4897H19.5599L11.6404 8.96429H11.6408ZM9.27734 11.7115L8.50362 10.6049L2.34737 1.79901H4.9978L9.96597 8.90562L10.7397 10.0123L17.1977 19.2498H14.5473L9.27734 11.712V11.7115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5599,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.812dee666b34997a7d04f4c8c51b8545.svg";
export { ForwardRef as ReactComponent };